"use strict";

exports.__esModule = true;
exports.NotificationPopupWidget = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _styledComponents = require("styled-components");
var _Core = require("../../Core");
var _safeUrl = require("../../../Utils/safeUrl");
var _icons = require("@blueprintjs/icons");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var getTitle = function getTitle(type, translate) {
  switch (type) {
    case "info":
      return translate("UserNotification.Type.Info", "Info");
    case "warning":
      return translate("UserNotification.Type.Warning", "Warning");
    default:
      break;
  }
};
var getIcon = function getIcon(type) {
  switch (type) {
    case "info":
      return _icons.IconNames.INFO_SIGN;
    case "warning":
      return _icons.IconNames.WARNING_SIGN;
    default:
      break;
  }
};
var NotificationPopupWidget = exports.NotificationPopupWidget = function NotificationPopupWidget(props) {
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var translator = (0, _react.useContext)(_Core.TranslatorContext);
  var translate = translator.translate;
  var onClickYesButton = props.onClickYesButton,
    notification = props.notification;
  return /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    className: theme.bodyClassName,
    isOpen: true,
    onClose: onClickYesButton,
    style: {
      width: "600px",
      maxHeight: "90vh"
    },
    title: getTitle(notification.type, translate),
    "data-testid": "NotificationPopupWidget.popup.dialog",
    icon: getIcon(notification.type)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG_BODY
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    "data-testid": "NotificationPopupWidget.popup.name"
  }, notification.name), /*#__PURE__*/_react["default"].createElement(_core.TextArea, {
    "data-testid": "NotificationPopupWidget.popup.message",
    style: {
      width: "100%",
      maxHeight: "70vh",
      backgroundColor: "#ced9e080"
    },
    value: notification.message,
    readOnly: true,
    autoResize: true
  }), notification.link ? /*#__PURE__*/_react["default"].createElement(_core.InputGroup, {
    "data-testid": "NotificationPopupWidget.popup.link",
    style: {
      marginTop: "15px",
      backgroundColor: "#ced9e080",
      cursor: "pointer"
    },
    value: notification.link,
    readOnly: true,
    onClick: function onClick() {
      return (0, _safeUrl.safeWindowOpen)(notification.link);
    }
  }) : null));
};